import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import { Observable, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ConfigService } from './config.service';
import { ResponseModel } from '../../models/response.model';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  protected envUrl: string;
  private configLoaded = false;
  private readonly platformLocation = inject(PlatformLocation);

  constructor(protected http: HttpClient, private configService: ConfigService) {
    this.envUrl = environment.baseUrl;
    this.configService.loadSysConfig(this.platformLocation).subscribe(config => {
      this.envUrl = config.baseUrl;
      this.configLoaded = true;
      
    });
  }

  public getData(route: string): Observable<any> {
  
    
    return this.configService.loadSysConfig(this.platformLocation).pipe(
      switchMap(config => {
        const baseurl = config.baseUrl;
        const url = this.createCompleteRoute(route, baseurl);
        return this.http.get(url, this.generateHeaders());
      })
    );
  }


  public postData(route: string, data: any): Observable<any> {
   
    return this.configService.loadSysConfig(this.platformLocation).pipe(
      switchMap(config => {
        const baseurl = config.baseUrl;
        const url = this.createCompleteRoute(route, baseurl);
        return this.http.post(url, data, this.generateHeaders());
      })
    );

  }
  public postDataWithoutParamter(route: string) {
    
    return this.configService.loadSysConfig(this.platformLocation).pipe(
      switchMap(config => {
        const baseurl = config?.baseUrl || this.envUrl;
        const url = this.createCompleteRoute(route, baseurl);
        return this.http.post(url, {}, this.generateHeaders());
      })
    );
  }

  public post(route: string, body: any): Observable<ResponseModel> {
   
    return this.configService.loadSysConfig(this.platformLocation).pipe(
      switchMap(config => {
        const baseurl = config?.baseUrl || this.envUrl;
        const url = this.createCompleteRoute(route, baseurl);
        return this.http.post<ResponseModel>(url, body, this.generateHeaders());
      })
    );
  }

  protected createCompleteRoute = (route: string, envAddress: string) => {
    const fullUrl = `${envAddress}${route}`;
    return fullUrl;
  }

  protected generateHeaders = (): { headers: HttpHeaders } => {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    };
  }
}
